import { render } from "./PreorderNav.vue?vue&type=template&id=5891faa6&scoped=true"
import script from "./PreorderNav.vue?vue&type=script&lang=js"
export * from "./PreorderNav.vue?vue&type=script&lang=js"

import "./PreorderNav.vue?vue&type=style&index=0&id=5891faa6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5891faa6"]])

export default __exports__